import { ContractType } from "./contract";
import { OfferTypeEnum } from "./offerType";

export interface Fee {
    id: string;
    erpId: string;
    name: string;
    allowPurchase: boolean;
    allowSale: boolean;
    value?: number;
    sortOrder: number;
    isDefault: boolean;
    allowedOfferTypes: OfferTypeEnum[];
    allowedContractTypes: ContractType[];
    allowedCommodities: number[];
}

export interface FeeThin {
    id: string;
    name: string;
    value?: number;
    isDefault: boolean;
}

export function getFeeThin(f: Fee): FeeThin {
    const fee: FeeThin = {
        id: f.id, 
        name: getFeeName(f.name, f.sortOrder), 
        value: f.value,
        isDefault: f.isDefault
    }; 
    return fee; 
}

export function getFeeName(name?: string, sortOrder?: number): string {
    return name ?? `Fee #${sortOrder}`;
}